"use client"

import { useState } from "react"

import styled from "styled-components"
import { selectIsInviteMembersModalOpen } from "features/common/model/selectors/appSelectors"
import { setIsInviteMembersModalOpen } from "features/common/model/slice/appSlice"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { Button, Form, Input, Modal, Typography, Flex, Select, message } from "shared/ui"
import { familySelector } from "features/team/model/selectors/teamSelectors"
import { NOTIFICATION_TYPES , showNotification } from "features/common/notifications"
import { useTranslation } from "react-i18next"

import { sendInvitesToFamilyThunk } from "../model/slice/teamSlice"

const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const InviteMembersModal = () => {
  const { t } = useTranslation()
  const [emails, setEmails] = useState<string[]>([])
  const dispatch = useAppDispatch()
  const isInviteMembersModalOpen = useAppSelector(selectIsInviteMembersModalOpen)
  const { Text } = Typography
  const familyData = useAppSelector(familySelector)


  const [form] = Form.useForm()

  const handleCopyLink = () => {
    navigator.clipboard.writeText(link)
    showNotification({
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Link copied',
      message: t('l_notification_inviteLinkCopied')
    })
  }

  const handleChange = (value: string[]) => {
    const validEmails = value.filter(email => isValidEmail(email))

    if (value.length > validEmails.length) {
      message.warning('Invalid email format detected!')
    }

    setEmails(validEmails)
  }

  const hendleSendInvite = () => {
    const to = emails
    dispatch(sendInvitesToFamilyThunk({ to }))
    handleClose()
  } 

  const link = familyData?.invite_hash ? `${window.location.origin}/invite?fchash=${familyData.invite_hash}` : ''

  const handleClose = () => {
    setEmails([])
    dispatch(setIsInviteMembersModalOpen(false))
  }


  return (
    <Modal open={isInviteMembersModalOpen}
      title={t('l_settings_inviteMembersTitle')}
      footer={null}
      width={480}
      destroyOnClose={true}
      onCancel={ handleClose }
    >
      <Text type="secondary">
        {t('l_settings_inviteMembersMsg')}
      </Text>
      
      <SContentContainer>
        <Form form={form}
          layout="vertical"
          preserve={false}
          initialValues={{ items: [{}] }}
          requiredMark="optional"
        >

          <Form.Item
            label={t('l_common_inviteByLink')}
          >
            <Flex style={{ width: "100%" }}
              gap="8px"
            >
              <Input size="large"
                readOnly
                style={{ flex: 1, 
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis" }}
                value={ link }
              />
              
              <Button size="large"
                style={{ width: 72 }}
                onClick={handleCopyLink}
              >
                {t('a_common_copy')}
              </Button>
            </Flex>
          </Form.Item>

          <Form.Item
            label={t('l_common_inviteByEmail')}
          >
            <Flex style={{ width: "100%" }}
              gap="8px"
            >
              <Select
                size="large"
                mode="tags"
                placeholder=""
                open={false}
                onChange={handleChange}
                suffixIcon={null}
                value={emails}
                style={{ flex: 1 }}
              />

              <Button size="large"
                type="primary"
                style={{ width: 72 }}
                disabled={emails.length === 0}
                onClick={hendleSendInvite}
              >
                {t('a_common_invite')}
              </Button>
            </Flex>
          </Form.Item>
        </Form>
      </SContentContainer>
    </Modal>
  )
}

const SContentContainer = styled.div`
  margin-top: 24px
`

